"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType[MessageType["OPEN"] = 0] = "OPEN";
    MessageType[MessageType["OPEN_ACK"] = 12] = "OPEN_ACK";
    MessageType[MessageType["PING"] = 8] = "PING";
    MessageType[MessageType["PONG"] = 9] = "PONG";
    MessageType[MessageType["JOIN"] = 1] = "JOIN";
    MessageType[MessageType["JOIN_ACK"] = 3] = "JOIN_ACK";
    MessageType[MessageType["JOIN_ERROR"] = 4] = "JOIN_ERROR";
    MessageType[MessageType["LEAVE"] = 2] = "LEAVE";
    MessageType[MessageType["LEAVE_ACK"] = 5] = "LEAVE_ACK";
    MessageType[MessageType["LEAVE_ERROR"] = 6] = "LEAVE_ERROR";
    MessageType[MessageType["EVENT"] = 7] = "EVENT";
    MessageType[MessageType["EVENT_ERROR"] = 10] = "EVENT_ERROR";
    MessageType[MessageType["EVENT_COMPLETE"] = 11] = "EVENT_COMPLETE";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=MessageType.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/adonis-client/dist/messages/MessageType.js
// module id = 62
// module chunks = 118